<template>
  <div class="contextmenu" @contextmenu.prevent>
    <b-button-group vertical :style="{ top: scrollTop + xy[1] + 'px', left: xy[0] + 'px' }">
      <b-button variant="light" v-for="(click, text, i) in menu" :key="i" @click="click(text)" v-text="$t(text)" />
      <!-- <b-button variant="light" v-text="$t('닫기')" /> -->
    </b-button-group>
  </div>
</template>

<script>
export default {
  props: ['menu', 'xy'],
  computed: {
    scrollTop() { return window.scrollY },
  },
}
</script>

<style>
/* .contextmenu {
  position: absolute;
  inset: 0;
  z-index: 99;
}

.contextmenu::before {
  content: '';
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, .2);
} */

.contextmenu>div {
  position: absolute;
  /* box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23); */
  background-color: #ffffff !important;
  box-shadow: 0 10px 20px rgba(82, 63, 105, 0.15);
  border-radius: 0.475rem;
  z-index: 99;
}

.contextmenu button {
  background-color: #ffffff !important;
  text-align: left;
  white-space: nowrap;
}
</style>